import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Banner from "../img/veezy.png";

function Jumbotron() {
  return (
    <div className="md:min-h-screen  flex flex-col items-center justify-center pt-32 pb-60  md:px-4 md:py-8 overflow-x-hidden shadow-lg bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,#07031C_0%,#241D4A_30.52%,#07031C_64.32%)]">
      <div className="flex flex-col md:flex-row gap-12 md:gap-20 justify-center items-center w-full max-w-6xl">

        {/* Block 1 */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="w-full max-w-md text-left"
        >
          <div className="md:flex hidden justify-start items-center space-x-3 mb-2">
            <motion.span
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="font-normal text-4xl md:text-[52px] leading-[119%] tracking-[0px] text-[#D4F5F9] font-lato"
            >
              Buy
            </motion.span>

            <motion.span
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="font-normal text-4xl md:text-[52px] leading-[119%] tracking-[0px] text-white font-lato"
            >
              &amp;
            </motion.span>

            <motion.span
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="font-normal text-4xl md:text-[52px] leading-[119%] tracking-[0px] text-[#F2C493] font-lato"
            >
              Invest
            </motion.span>
          </div>


  <div className="md:hidden flex justify-start items-center  mb-2">
            <motion.span
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="font-normal  text-5xl md:text-[52px] leading-[119%] tracking-[0px] text-[#D4F5F9] font-lato pl-9"
            >
              Buy
            </motion.span>

            <motion.span
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="font-normal text-5xl md:text-[52px] leading-[119%] tracking-[0px] text-white font-lato"
            >
              &amp;
            </motion.span>

            <motion.span
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="font-normal text-5xl md:text-[52px] leading-[119%] tracking-[0px] text-[#F2C493] font-lato"
            >
              Invest
            </motion.span>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="w-fit md:pl-0 pl-9"
          >
            <p className=" md:flex hidden whitespace-nowrap font-lato font-normal text-3xl md:text-[52px] leading-[119%] tracking-[0px] text-white mb-4">

              
              Crypto Tokens Easily
            </p>

               <p className=" md:hidden flex  whitespace-nowrap font-lato font-normal  text-5xl leading-[119%] tracking-[0px] text-white mb-4">

              
              Crypto <br/> Tokens <br/> Easily
            </p>

            <p className="md:flex hidden  font-lato font-normal text-sm leading-relaxed text-white mb-6">
              Capital Nest is a crypto investment platform that enables both<br className="hidden md:block" />
              Crypto newbies and pros to invest, maintain, and grow a<br className="hidden md:block" />
              portfolio of digital assets.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 1.2 }}
          >
            <Link
              to="/signup"
              className="w-[200px] hidden  md:mt-0 mt-16 md:w-[285px] h-[55px] md:h-[67px] rounded-[15px] px-6 md:px-[100px] py-3 bg-gradient-to-r from-[#DFBD69] to-[#241D49] text-white font-istok font-medium text-[16px] leading-[100%] md:flex items-center justify-center hover:opacity-90 transition duration-300"
            >
              Get Started
            </Link>

            <Link
  to="/signup"
  className="mx-auto md:hidden w-[80%] md:mt-0 mt-16 md:w-[285px] h-[55px] md:h-[67px] rounded-[15px] px-6 md:px-[100px] py-3 bg-gradient-to-r from-[#DFBD69] to-[#241D49] text-white font-istok font-medium text-[16px] leading-[100%] flex items-center justify-center hover:opacity-90 transition duration-300"
>
  Get Started
</Link>
          </motion.div>
        </motion.div>

        {/* Block 2 - Image hidden on small screens */}
        <div className="hidden md:flex py-8 px-8 w-full max-w-md justify-end items-center">
          <motion.img
            src={Banner}
            alt="Banner"
            className="w-[350px] h-[350px] rotate-0 opacity-100"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Jumbotron;
